export default __webpack_public_path__ + "static/media/pathrise-logo-indigo.feafe949.svg";